import React, { useState } from "react";
import { deleteBlog } from "../../../utils/apis/func";
import { useNavigate } from "react-router-dom";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string | undefined;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ isOpen, onClose, id }) => {
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    const res = await deleteBlog(id);

    if (res.status === 201 || res.status === 200 || res.status === 204) {
      navigate("/blog");
    } else {
      alert("something went wrong");
    }
    setIsDeleting(false);
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75">
      <div className="bg-white p-6 rounded-md">
        <h2 className="text-lg font-medium mb-4">Confirm Deletion</h2>
        <p className="mb-4">Are you sure you want to delete this blog?</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="mr-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300"
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="bg-[#88087B] text-white px-4 py-2 rounded-md hover:bg-[#88087B]/75"
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
